import {
  Card,
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  Stack,
  Typography,
  Switch,
  ToggleButtonGroup,
  ToggleButton,
  Button,
} from "@mui/material";

import { SHOW_TYPES } from "Constants/Survey";

import { useAppDispatch, useAppSelector } from "Hooks/useRedux";

import {
  changeTravelShowType,
  toggleVisibility,
  changeHeatMapMode,
  togglePointwiseShow,
  changeMarkerMode,
  changeType,
  Type,
} from "Redux/travelSlice";
import {
  changeHeatMap2Mode,
  SelectingType,
  ColorStepType,
  changeHeatMap2ColorStep,
  toggleShowHeatMap2Numbers,
  changeApplySelected,
} from "Redux/trafficZoneSlices";
import { useState } from "react";

export default function Travel() {
  const dispatch = useAppDispatch();

  const { travelShowType, visible, markerMode, heatmapMode, pointwiseShow, type } = useAppSelector((state) => state.travel);
  const {
    heatMap2Mode,
    visible: zonesVisible,
    selectingType,
    colorStep,
    showHeatMap2Numbers,
    autoApply,
  } = useAppSelector((state) => state.trafficZones);

  const label = { inputProps: { "aria-label": "Switch demo" } };

  const handleHeatMap2Mode = (event: React.MouseEvent<HTMLElement>, newMode: SelectingType) => {
    if (newMode !== null) {
      dispatch(changeHeatMap2Mode(newMode));
    }
  };

  const handleTravelShowType = (event: React.MouseEvent<HTMLElement>, newMode: SelectingType) => {
    if (newMode !== null) {
      dispatch(changeTravelShowType(Number(newMode)));
    }
  };

  const handleMarkerShowMode = (event: React.MouseEvent<HTMLElement>, newValue: SelectingType[]) => {
    if (newValue.length) {
      dispatch(changeMarkerMode(newValue));
    }
  };

  const handleHeatMapShowMode = (event: React.MouseEvent<HTMLElement>, newValue: SelectingType) => {
    if (newValue !== null) {
      dispatch(changeHeatMapMode(newValue));
    }
  };

  const SPECTRUM_NUMBERS = [1200, 800, 400, 240, 120];

  const handleShowHeatMap2Numbers = () => {
    dispatch(toggleShowHeatMap2Numbers());
  };

  const handleMarkerPointWise = () => {
    dispatch(togglePointwiseShow());
  };

  const handleheatMap2Step = (event: React.MouseEvent<HTMLElement>, step: ColorStepType) => {
    if (step !== null) {
      dispatch(changeHeatMap2ColorStep(step));
    }
  };

  const handleSwitch = () => {
    dispatch(toggleVisibility());
    dispatch(changeApplySelected(false));
    // dispatch(changeDataForPost(dataForPost));
  };

  const handleChangeType = (event: React.MouseEvent<HTMLElement>, newType: Type) => {
    if (newType !== null) {
      dispatch(changeType(newType));
    }
  };

  const handleOptions = () => {
    if (travelShowType === 0) {
      return (
        <Stack direction="row" sx={{ justifyContent: "space-between" }}>
          <ToggleButtonGroup value={markerMode} onChange={handleMarkerShowMode} aria-label="marker-mode">
            <ToggleButton
              value="source"
              aria-label="source"
              style={{
                width: "56px",
                height: "56px",
                backgroundColor: markerMode.includes("source") ? "#4754CA" : "",
                color: markerMode.includes("source") ? "#fff" : "",
              }}
            >
              مبدا
            </ToggleButton>
            <ToggleButton
              value="destination"
              aria-label="destination"
              style={{
                width: "56px",
                height: "56px",
                backgroundColor: markerMode.includes("destination") ? "#4754CA" : "",
                color: markerMode.includes("destination") ? "#fff" : "",
              }}
            >
              مقصد
            </ToggleButton>
          </ToggleButtonGroup>
          <Button onClick={handleMarkerPointWise} variant={pointwiseShow ? "contained" : "light"} style={{ marginRight: "10px" }}>
            نمایش نقطه ای
          </Button>
        </Stack>
      );
    }
    if (travelShowType === 1) {
      return (
        <Stack direction="row" sx={{ justifyContent: "space-between" }}>
          <ToggleButtonGroup value={heatmapMode} exclusive onChange={handleHeatMapShowMode} aria-label="heatmap-mode">
            <ToggleButton
              value="source"
              aria-label="source"
              style={{
                width: "56px",
                height: "56px",
                backgroundColor: heatmapMode === "source" ? "#4754CA" : "",
                color: heatmapMode === "source" ? "#fff" : "",
              }}
            >
              مبدا
            </ToggleButton>
            <ToggleButton
              value="destination"
              aria-label="destination"
              style={{
                width: "56px",
                height: "56px",
                backgroundColor: heatmapMode === "destination" ? "#4754CA" : "",
                color: heatmapMode === "destination" ? "#fff" : "",
              }}
            >
              مقصد
            </ToggleButton>
          </ToggleButtonGroup>
        </Stack>
      );
    }
    if (travelShowType === 2) {
      return (
        <Stack direction="row">
          <Stack direction="row" sx={{ justifyContent: "space-between" }}>
            <ToggleButtonGroup value={heatMap2Mode} exclusive onChange={handleHeatMap2Mode} aria-label="heatMap2-mode">
              <ToggleButton
                value="source"
                aria-label="source-mode"
                style={{
                  width: "56px",
                  height: "56px",
                  backgroundColor: heatMap2Mode === "source" ? "#4754CA" : "",
                  color: heatMap2Mode === "source" ? "#fff" : "",
                }}
              >
                مبدا
              </ToggleButton>
              <ToggleButton
                value="destination"
                aria-label="destination-mode"
                style={{
                  width: "56px",
                  height: "56px",
                  backgroundColor: heatMap2Mode === "destination" ? "#4754CA" : "",
                  color: heatMap2Mode === "destination" ? "#fff" : "",
                }}
              >
                مقصد
              </ToggleButton>
            </ToggleButtonGroup>
            <Button onClick={handleShowHeatMap2Numbers} variant={showHeatMap2Numbers ? "contained" : "light"} sx={{ mx: "10px" }}>
              نمایش اعداد
            </Button>
          </Stack>
          <Stack>
            <ToggleButtonGroup value={colorStep} exclusive onChange={handleheatMap2Step} aria-label="text alignment">
              {SPECTRUM_NUMBERS.map((s, index) => (
                <ToggleButton
                  className="fa-number"
                  value={index + 1}
                  aria-label={`top-${s}`}
                  style={{
                    width: "56px",
                    height: "56px",
                    backgroundColor: colorStep === index + 1 ? "#4754CA" : "",
                    color: colorStep === index + 1 ? "#fff" : "",
                  }}
                >
                  طیف {s}
                </ToggleButton>
              ))}
            </ToggleButtonGroup>
          </Stack>
        </Stack>
      );
    }
  };

  return (
    <Card sx={{ p: 1.5 }}>
      <Stack spacing={2} direction="row" style={{ alignItems: "center" }}>
        <ToggleButtonGroup value={type} exclusive onChange={handleChangeType} aria-label="type-mode">
          <ToggleButton
            value="people"
            aria-label="people"
            style={{
              width: "76px",
              height: "56px",
              backgroundColor: type === "people" ? "#4754CA" : "",
              color: type === "people" ? "#fff" : "",
            }}
          >
            تقاضا
          </ToggleButton>
          <ToggleButton
            value="bus"
            aria-label="bus"
            style={{
              width: "76px",
              height: "56px",
              backgroundColor: type === "bus" ? "#4754CA" : "",
              color: type === "bus" ? "#fff" : "",
            }}
          >
            اتوبوس
          </ToggleButton>
          <ToggleButton
            value="taxi"
            aria-label="taxi"
            style={{
              width: "76px",
              height: "56px",
              backgroundColor: type === "taxi" ? "#4754CA" : "",
              color: type === "taxi" ? "#fff" : "",
            }}
          >
            تاکسی
          </ToggleButton>
        </ToggleButtonGroup>
        {handleOptions()}
        <ToggleButtonGroup value={Number(travelShowType)} onChange={handleTravelShowType} exclusive aria-label="travel-show-type">
          {SHOW_TYPES.map((t, index) => (
            <ToggleButton
              value={index}
              aria-label={`travel-mode-${index}`}
              style={{
                width: "80px",
                height: "56px",
                backgroundColor: Number(travelShowType) === index ? "#4754CA" : "",
                color: Number(travelShowType) === index ? "#fff" : "",
              }}
            >
              {t}
            </ToggleButton>
          ))}
        </ToggleButtonGroup>
        <Stack direction="row" sx={{ justifyContent: "space-between", alignItems: "center" }}>
          <Typography sx={{ fontSize: "18px !important", mb: "0 !important" }}>نمایش</Typography>
          <Switch {...label} onChange={handleSwitch} checked={visible} />
        </Stack>
      </Stack>
    </Card>
  );
}
